<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';
import { INBOX_TYPES } from 'dashboard/helper/inbox';
import { useConfig } from 'dashboard/composables/useConfig';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  qualityRatingsByInbox: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits([
  'edit',
  'delete',
  'viewReport',
  'resume',
  'pause',
  'restart',
  'continueNew',
  'retryFailed',
  'viewFailures',
  'viewReplies',
]);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleViewReport = campaign => emit('viewReport', campaign);
const handleResume = campaign => emit('resume', campaign);
const handlePause = campaign => emit('pause', campaign);
const handleRestart = campaign => emit('restart', campaign);
const handleContinueNew = campaign => emit('continueNew', campaign);
const handleRetryFailed = campaign => emit('retryFailed', campaign);
const handleViewFailures = campaign => emit('viewFailures', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status || campaign.status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :sending-start-time="campaign.sending_start_time || campaign.start_time"
      :sending-end-time="campaign.sending_end_time || campaign.end_time"
      :pause-reason="campaign.pause_reason"
      :is-live-chat-type="isLiveChatType"
      :sent-count="campaign.sent_count || 0"
      :failed-count="campaign.failed_count || 0"
      :total-contacts="campaign.total_contacts || 0"
      :audience-names="campaign.audience_names || []"
      :conversations-with-replies="campaign.conversations_with_replies || campaign.reply_count || 0"
      :negative-replies="campaign.negative_replies || 0"
      :quality-rating="qualityRatingsByInbox[campaign.inbox?.id] || ''"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @view-report="handleViewReport(campaign)"
      @resume="handleResume(campaign)"
      @pause="handlePause(campaign)"
      @restart="handleRestart(campaign)"
      @continue-new="handleContinueNew(campaign)"
      @retry-failed="handleRetryFailed(campaign)"
      @view-failures="handleViewFailures(campaign)"
      @view-replies="filter => emit('viewReplies', campaign, filter)"
    />
  </div>
</template>
